import React from 'react';

const Loading = ({ size = 'medium', text = 'Loading...' }) => {
  const sizeClasses = {
    small: 'w-6 h-6',
    medium: 'w-10 h-10',
    large: 'w-16 h-16'
  };

  return (
    <div className="flex flex-col items-center justify-center p-4">
      <div 
        className={`loading-spinner ${sizeClasses[size]}`}
        style={{
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #3b82f6',
          borderRadius: '50%',
          animation: 'spin 2s linear infinite'
        }}
      />
      {text && <p className="mt-2 text-gray-600">{text}</p>}
    </div>
  );
};

export default Loading;